import React from "react";
import { cn } from "@gettactic/helpers";

export interface SimpleTableProps
  extends React.HTMLAttributes<HTMLTableElement> {
  /**
   * Replaces the scroll container's own card treatment (shadow, radius,
   * overflow) — for a table already sitting inside a card, where the default
   * would draw a second one. Omit for the standalone look.
   */
  wrapperClassName?: string;
}

export const SimpleTable: React.FC<SimpleTableProps> = ({
  wrapperClassName,
  ...props
}) => {
  return (
    <div
      className={
        wrapperClassName ??
        "simple-table bg-[#F0F4F7] shadow-md rounded-lg overflow-hidden"
      }
    >
      <table
        cellPadding={0}
        cellSpacing={0}
        {...props}
        className={cn("table", props.className)}
      />
    </div>
  );
};

export const SimpleTableHeader: React.FC<
  React.HTMLAttributes<HTMLTableSectionElement>
> = (props) => {
  return (
    <thead {...props} className={cn("table-header-group", props.className)} />
  );
};

export const SimpleTableBody: React.FC<
  React.HTMLAttributes<HTMLTableSectionElement>
> = (props) => {
  return (
    <tbody {...props} className={cn("table-row-group", props.className)} />
  );
};

export const SimpleTableRow: React.FC<
  React.HTMLAttributes<HTMLTableRowElement>
> = ({ children, ...props }) => {
  return (
    <tr {...props} className={cn("table-row", props.className)}>
      {children}
    </tr>
  );
};

export const SimpleTableHeaderCell: React.FC<
  React.ThHTMLAttributes<HTMLTableCellElement>
> = (props) => {
  return (
    <th
      {...props}
      className={cn(
        "table-cell px-4 py-2.5 text-left font-bold text-[#778086] uppercase",
        props.className
      )}
    />
  );
};

export const SimpleTableCell: React.FC<
  React.TdHTMLAttributes<HTMLTableCellElement> & {
    cellInnerClassName?: string;
  }
> = ({ children, cellInnerClassName, ...props }) => {
  return (
    <td
      {...props}
      className={cn("table-cell border-0 text-left", props.className)}
    >
      <div className={cn("border-b bg-white px-4 py-4", cellInnerClassName)}>
        {children || <>&nbsp;</>}
      </div>
    </td>
  );
};
